/**********************************************************
FAQ Card
**********************************************************/
import React from 'react';


const FAQCard = ({ faq, _class, onClick }) => {
  return (
    <div className={`col s12 m6 l3 ${_class}`}>
      <a className="black-text" onClick={() => onClick(faq)}>
        <div className={`card ${faq.cardColor} hoverable`} >
          <div className="card-content center-align">
            <i className={`material-icons ${faq.iconColor} medium`}>{ faq.icon }</i>
            <h6><b>{ faq.title }</b></h6>
            <p>{ faq.extra }</p>
          </div>
        </div>
      </a>
    </div>
  );
}


export default FAQCard;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/documentation/faq_card.js